import { TextField, TextFieldProps } from "@mui/material";
import { FieldValues, Control, Controller, Path } from "react-hook-form";
import { NumericFormat } from "react-number-format";

type PropsType<TField extends FieldValues> = {
    control: Control<TField>;
    name: Path<TField>;
    label?: string;
};
export default function RHFNumericFormat<TField extends FieldValues>(
    { control, name, type, ...props }: Omit<TextFieldProps, 'defaultValue'> & PropsType<TField>) {
    return (
        <Controller
            render={({ field: { value, onChange }, fieldState: { error } }) => <NumericFormat
                onValueChange={(v) => onChange(v.value)}
                {...props}
                customInput={TextField}
                value={value}
                error={!!error}
                helperText={error?.message}
                valueIsNumericString
                thousandSeparator />}
            name={name}
            control={control}
        />
    )
}
